function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Image, Upload, Modal, InputNumber, Flex, Descriptions, Switch, Radio, Space, DatePicker, Alert, notification } from 'antd';
import ImgCrop from 'antd-img-crop';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import { PlusCircleFill, Youtube } from "react-bootstrap-icons";
import Common from "../../includes/Common";
import { useNavigate } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var OrderPrintedTickets = function OrderPrintedTickets(_ref) {
  var handler = _ref.handler,
    event = _ref.event;
  var navigate = useNavigate();
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(5000),
    _useState6 = _slicedToArray(_useState5, 2),
    maximumAudience = _useState6[0],
    setMaximumAudience = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    paymentOptions = _useState8[0],
    setPaymentOptions = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isPaymentOptionsLoading = _useState10[0],
    setIsPaymentOptionsLoading = _useState10[1];
  var _useState11 = useState(300),
    _useState12 = _slicedToArray(_useState11, 2),
    count = _useState12[0],
    setCount = _useState12[1];
  var getEventPrice = function getEventPrice(count) {
    var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GN";
    var price = 0;
    if (countryCode == "GN") {
      price = 1000;
      return (price * count).toLocaleString("Fr");
    }
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    formData.append("pg", values.pg);
    formData.append("event_id", event.id);
    formData.append("mobile", values.mobile);
    formData.append("ticket_print_quantity", values.ticket_print_quantity);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'orderprinttickets', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 201) {
        window.location.href = response.data.payment_url;
      }
      if (response.data.status == 200) {
        handler();
        navigate('/home/compte/m-events');
      }
      if (response.data.status < 200 || response.data.status > 299) setErrorMessage(response.data.message);
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };
  useEffect(function () {
    setIsPaymentOptionsLoading(true);
    form.setFieldsValue({
      mobile: Common.currentUser.mobile.slice(3),
      ticket_print_quantity: count
    });
    axios.get(Common.baseApiUrl + "getpgs").then(function (response) {
      if (response.data.status == 200) {
        response.data.pgs.forEach(function (pg) {
          setPaymentOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: pg.id,
              label: /*#__PURE__*/_jsxs(Flex, {
                gap: "small",
                justify: "center",
                align: "center",
                vertical: true,
                children: [/*#__PURE__*/_jsx(Image, {
                  preview: false,
                  width: "90px",
                  src: "drawables/" + pg.logo
                }), /*#__PURE__*/_jsx("b", {
                  children: pg.label
                })]
              })
            }]);
          });
        });
        if (response.data.pgs.length > 0) form.setFieldsValue({
          pg: response.data.pgs[0].id
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setIsPaymentOptionsLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "large",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Nbre tickets \xE0 imprimer",
            name: "ticket_print_quantity",
            rules: [{
              required: true,
              message: "Veuillez choisir une option"
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              onChange: function onChange(e) {
                setCount(e);
              },
              style: {
                width: "150px"
              }
            })
          })
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Descriptions, {
          bordered: true,
          column: 1,
          title: /*#__PURE__*/_jsx("b", {
            children: "Infos commande"
          }),
          items: [{
            key: 1,
            label: /*#__PURE__*/_jsx("b", {
              children: "Forfait"
            }),
            children: /*#__PURE__*/_jsxs("span", {
              children: ["Naatou event - Forfait ", count]
            })
          }, {
            key: 2,
            label: /*#__PURE__*/_jsx("b", {
              children: "Montant"
            }),
            children: /*#__PURE__*/_jsx("span", {
              children: (count * 1100).toLocaleString("Fr")
            })
          }]
        })
      }), /*#__PURE__*/_jsx(Row, {
        className: "d-flex justify-content-center",
        children: /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 10,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "pg",
            children: /*#__PURE__*/_jsx(Radio.Group, {
              options: paymentOptions
            })
          })
        })
      }), /*#__PURE__*/_jsx(Row, {
        className: "d-flex justify-content-center",
        children: /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 10,
          children: /*#__PURE__*/_jsxs(Space.Compact, {
            children: [/*#__PURE__*/_jsx(Form.Item, {
              label: "Votre num\xE9ro mobile",
              name: "mobile",
              rules: [{
                required: true,
                message: "Veuillez entrer un numéro mobile"
              }],
              children: /*#__PURE__*/_jsx(Input, {
                width: "210px"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              label: " ",
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormLoading,
                type: "primary",
                htmlType: "submit",
                children: /*#__PURE__*/_jsx("b", {
                  children: "Payer"
                })
              })
            })]
          })
        })
      })]
    })
  });
};
export default OrderPrintedTickets;